import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

export enum EComparisonNotificationCategory {
  Add = 'add',
  Limit = 'limit',
  Remove = 'remove',
}

export type ComparisonNotificationState = {
  /** id последнего объявления **/
  lastOfferId: number;
  /** тип запроса **/
  type: string;
};

export type ComparisonNotificationPopupState = {
  comparisonNotification: ComparisonNotificationState | null;
};

const initialState: ComparisonNotificationPopupState = { comparisonNotification: null };

export const { reducer: comparisonNotificationReducer, actions: comparisonNotificationActions } = createSlice({
  name: 'comparisonNotification',
  initialState,
  reducers: {
    setComparisonNotificationType: (state, action: PayloadAction<ComparisonNotificationState>) => {
      state.comparisonNotification = action.payload;
    },
    clearComparisonNotificationType: state => {
      state.comparisonNotification = null;
    },
  },
});
